import { useQuery } from "@tanstack/react-query"
import { Table, Tag } from "antd"
import type React from "react"
import { memo } from "react"
import { DragModal } from "@/components/Modal"
import { roleService } from "@/services/role/roleApi"

interface RoleAccountsModalProps {
  open: boolean
  roleId: number | string | null
  roleName: string
  onCancel: () => void
}

/**
 * Component Modal danh sách tài khoản thuộc vai trò (RoleAccountsModal)
 */
const RoleAccountsModal: React.FC<RoleAccountsModalProps> = memo(({ open, roleId, roleName, onCancel }) => {
  // Lấy danh sách tài khoản thuộc vai trò
  const { data: accountsResult, isFetching } = useQuery({
    queryKey: ["role_accounts", roleId],
    queryFn: () => roleService.getAccounts(roleId!),
    enabled: !!roleId && open,
  })

  const dataSource = accountsResult?.data?.map((item: any) => item.admin).filter(Boolean) || []

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 60,
      align: "center" as const,
    },
    {
      title: "Tên đăng nhập",
      dataIndex: "username",
      key: "username",
      width: 150,
    },
    {
      title: "Họ và tên",
      dataIndex: "full_name",
      key: "full_name",
      width: 180,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Trạng thái",
      dataIndex: "is_active",
      key: "is_active",
      width: 110,
      align: "center" as const,
      render: (value: number) => (
        <Tag color={value === 1 ? "success" : "error"}>{value === 1 ? "Hoạt động" : "Khóa"}</Tag>
      ),
    },
  ]

  return (
    <DragModal
      centered
      title={`Tài khoản sở hữu vai trò: ${roleName}`}
      open={open}
      onCancel={onCancel}
      width={700}
      destroyOnHidden={true}
      footer={null}
    >
      <Table
        bordered
        dataSource={dataSource}
        columns={columns}
        rowKey="id"
        pagination={{ pageSize: 10 }}
        loading={isFetching}
        size="small"
      />
    </DragModal>
  )
})

RoleAccountsModal.displayName = "RoleAccountsModal"

export default RoleAccountsModal
